// TODO: Review this way to set global variables
// TAG: GlobalVariable
var eeGlobal = eeGlobal || {};

